export default __webpack_public_path__ + "static/media/line-h-04.797b99f6.png";